import cn from 'classnames';
import Flex from '@creditflowresearch/uilib/Flex';
import IconArrowLeft from '@creditflowresearch/uilib/Icon/IconArrowLeft';
import IconTriangleArrowBottom from '@creditflowresearch/uilib/Icon/IconTriangleArrowBottom';
import IconArrowRight from '@creditflowresearch/uilib/Icon/IconArrowRight';

import styles from './datePickerHeader.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface INavSectionProps {
  label: string,
  isOpen: boolean,
  showArrows: boolean,
  onLabelClick: () => void,
  onPrev: () => void,
  onNext: () => void,
  prevDisabled: boolean,
  nextDisabled: boolean,
  dataTestPrev?: string,
  dataTestNext?: string,
  dataTestLabel?: string,
}

const NavSection = ({
  label,
  isOpen,
  showArrows,
  onLabelClick,
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  dataTestPrev,
  dataTestNext,
  dataTestLabel,
}: INavSectionProps) => (
  <Flex flex="1" align="center" justify="center" gap={ 2 }>
    { showArrows && (
      <IconButton
        icon={ <IconArrowLeft size={ 12 } /> }
        className={ styles.navBtn }
        onClick={ onPrev }
        disabled={ prevDisabled }
        dataTest={ dataTestPrev }
        ariaLabel="Previous"
      />
    ) }
    <Flex as="button" align="center" gap={ 4 } className={ styles.selectorBtn } onClick={ onLabelClick }>
      <span data-test={ dataTestLabel }>{ label }</span>
      <IconTriangleArrowBottom className={ cn(styles.dropdownArrow, { [styles.open]: isOpen }) } />
    </Flex>
    { showArrows && (
      <IconButton
        icon={ <IconArrowRight size={ 12 } /> }
        className={ styles.navBtn }
        onClick={ onNext }
        disabled={ nextDisabled }
        dataTest={ dataTestNext }
        ariaLabel="Next"
      />
    ) }
  </Flex>
);

export default NavSection;
